import React, { useState } from 'react';
import { ContentSection, Layout } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { ContractsOverview } from 'components/contracts/ContractsOverview';
import { DashboardMarketingCard } from 'components/dashboard-marketing-card/DashboardMarketingCard';
import { CustomerHappinessIndex } from 'components/customer-happiness-index/CustomerHappinessIndex';
import { Greeting } from 'components/greeting/Greeting';
import { PageHeader } from 'components/page-header/PageHeader';
import { useContracts } from 'components/contracts/useContracts';
import { DigitalRenewalSuccessNotification } from 'components/notifications/digital-renewal/success-notification';
import { NoConnectionNotification } from 'components/notifications/no-connection/NoConnectionNotification';
import { usePersonalDetails } from '../components/my-profile/usePersonalDetails';
import { DigitalRenewalEntryNotification } from 'components/digital-renewal/DigitalRenewalEntryNotification';
import { isDigitalRenewalEnabled } from '../config';

export const DashboardPage: React.FC = () => {
    const { t } = useTranslation('dashboard');
    const { data: contracts, isLoading: isLoadingContracts } = useContracts();
    const { data: personalDetails } = usePersonalDetails();
    const [hasMarketingCard, setHasMarketingCard] = useState(false);
    const [hasMarketingCardError, setHasMarketingCardError] = useState(false);
    const isContactEmailDefined = !!personalDetails?.contact?.email;

    return (
        <ContentSection pageWrapSize="medium">
            <PageHeader title={t('headline')} />
            <Greeting />

            <Layout>
                <Layout.Item default={hasMarketingCard ? '2/3' : '1/1'} m={'1/1'}>
                    <DigitalRenewalSuccessNotification />
                    {isDigitalRenewalEnabled ? <DigitalRenewalEntryNotification /> : <></>}
                    <ContractsOverview
                        contracts={contracts}
                        isLoadingContractsOverview={isLoadingContracts}
                        contractsOverviewLoadingError={!!isLoadingContracts}
                    />
                </Layout.Item>
                {hasMarketingCardError ? (
                    <Layout.Item default={'1/1'} m={'1/1'}>
                        <NoConnectionNotification />
                    </Layout.Item>
                ) : (
                    <Layout.Item default={'1/3'} m={'1/1'}>
                        <DashboardMarketingCard
                            contracts={contracts}
                            setHasMarketingCard={setHasMarketingCard}
                            setHasMarketingCardError={setHasMarketingCardError}
                        />
                    </Layout.Item>
                )}
                <Layout.Item default={hasMarketingCard ? '2/3' : '1/1'} m={'1/1'}>
                    {isContactEmailDefined && <CustomerHappinessIndex />}
                </Layout.Item>
            </Layout>
        </ContentSection>
    );
};
